import React, { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/store';
import EditTracking from '../editor/EditTracking';

export const initTrackingValues = {
  tracking: {
    background: ['shop now - image'],
    button: ['shop now - button'],
    sub_button: ['close - button'],
    never_show_button: ['never show - button']
  }
};
// rgba(95, 130, 146, 1)

const SimpleModalTracking: FC = () => {
  const dispatch = useDispatch();

  var tracking = useSelector((state: RootState) => state.trackings.tracking);

  const style = `
    .root_tracking {
      width: 100%;
      height: 100%;
      
      position: relative;
      background: none;
      overflow: hidden;
      
      .close_btn {
        width: 100%;
        position: absolute;
        right: 0;
        top: 6%;
      }

      .center {
        width: 100%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
  
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
      }
      .modal_wrapper {
        width: 100%;
        height: 26.25rem;
        position: relative;
      }

      .btn_wrapper {
        width: 100%;
        height: 2.6rem;
        
        position: absolute;
        bottom: 2rem;
      }

      .bottom_wrapper {
        width: 100%;
        height: 2.6rem;

        display: flex;
        align-items: center;
        justify-content: center;
      }

      .tracking_center {
        display: flex;
        align-items: center;
        justify-content: end;
      }
    }
    `;

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: style }}></style>
      <div className="root_tracking">
        <div className="close_btn tracking_center">
          <EditTracking value={tracking?.sub_button?.[0]} type="sub_button" />
        </div>
        <div className="center">
          <div className="modal_wrapper tracking_center">
            <EditTracking value={tracking?.background?.[0]} type="background" />
            <div className="btn_wrapper tracking_center">
              <EditTracking value={tracking?.button?.[0]} type="button" />
            </div>
          </div>
          <div className="bottom_wrapper tracking_center">
            <EditTracking
              value={tracking?.never_show_button?.[0]}
              type="never_show_button"
            />
          </div>
        </div>
      </div>
    </>
  );
};
export default SimpleModalTracking;
